import type { FC } from 'react';

import { useCncFlyInState } from '../../../hooks/useCncFlyInState';
import { useAppSelector } from '../../../hooks/useThunkDispatch';
import { cartSelectors } from '../../../selectors/cartSelectors';
import { EditOrderModeNotice } from './EditOrderModeNotice';
import styles from './EditOrderModeNoticeGoToCheckout.module.scss';

const EditOrderModeNoticeGoToCheckout: FC<React.PropsWithChildren<unknown>> = () => {
    const isEditMode = useAppSelector(cartSelectors.isInEditOrder);
    const { initCnc } = useCncFlyInState();

    if (!isEditMode) return null;

    return (
        <EditOrderModeNotice heading="Du ändrar i en beställning">
            <button
                type="button"
                className={styles.Link}
                onClick={() => {
                    initCnc();
                }}
                aria-haspopup="dialog"
            >
                Gå till varukorgen för att göra dina ändringar
            </button>
        </EditOrderModeNotice>
    );
};

export default EditOrderModeNoticeGoToCheckout;
